module.exports = __webpack_public_path__ + "static/img/mystery-box3-1.1956e44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-template/mystery-box3-1.png
// module id = 4Llt
// module chunks = 216